import React from "react";
import { BeautifulBulb, HealthAdvise } from "@utils/defaultImages";

const AISuggestionDisplay = ({
  aiResponse,
  onRegenerate,
  showRegenerateButton = false,
}) => {
  // Show loading/streaming animation
  const renderStreamingContent = () => {
    if (
      (aiResponse.isStreaming && !aiResponse.description) ||
      aiResponse.isLoading
    ) {
      return (
        <div className="flex items-center space-x-2 mb-3">
          <span className="text-xl">🤖</span>
          <div className="flex space-x-1">
            <div
              className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"
              style={{ animationDelay: "0ms" }}
            ></div>
            <div
              className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"
              style={{ animationDelay: "150ms" }}
            ></div>
            <div
              className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"
              style={{ animationDelay: "300ms" }}
            ></div>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
      <div className="bg-white rounded-2xl p-3 md:p-4 shadow-lg h-full">
        <div className="flex items-start gap-3">
          <div className="flex-1">
            {/* <button className="text-[#fff] cursor-default text-[12px] md:text-[14px] bg-gradient-to-r from-[#0771EF] to-[#15AAFC] rounded-full px-3 py-1.5 flex items-center gap-2 w-fit mb-3">
              <span className="bg-white rounded-full w-6 h-6 md:w-7 md:h-7 flex items-center justify-center">
                <Bulb className="w-3 h-3 md:w-4 md:h-4" />
              </span>
              AI Suggestion
            </button> */}
            <div className="flex items-center gap-3">
              <HealthAdvise className="w-6 h-6" />
              <h2 className="font-[600] font-[Lato] text-[14px] text-[#444444]">
                Personalized Health Advice
              </h2>
            </div>

            {aiResponse.error &&
            aiResponse.error !==
              "Unable to generate AI suggestions. Showing default message." ? (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-600 text-sm">{aiResponse.error}</p>
                <button
                  onClick={onRegenerate}
                  className="mt-2 text-blue-600 text-sm hover:text-blue-800"
                >
                  Try Again
                </button>
              </div>
            ) : (
              <>
                {renderStreamingContent()}

                {aiResponse.description && (
                  <div className="mt-2">
                    {aiResponse.isStreaming ? (
                      <div className="space-y-2">
                        <p className="text-[#4A5568] text-[14px] font-[Lato] leading-relaxed">
                          {aiResponse.description}
                          <span className="inline-block w-2 h-4 bg-blue-500 ml-1 animate-pulse"></span>
                        </p>
                      </div>
                    ) : (
                      <p className="text-[#898787] text-[14px] font-[400] font-[Lato] leading-relaxed whitespace-pre-line">
                        {aiResponse.description}
                      </p>
                    )}
                  </div>
                )}

                {
                  !aiResponse.isStreaming &&
                  <div className="bg-[#E6F8FF] border border-[#4CDBFF] border-dashed border-[0.5px] rounded-xl p-3 mt-3">
                  <div className="flex items-center gap-2">
                    <BeautifulBulb className="w-6 h-6" />
                    <h2 className="font-[600] font-[Lato] text-[14px] text-[#444444]">
                     Improvement Tip
                    </h2>
                  </div>
                  {aiResponse.improvementTip && (
                    <h3 className="text-[#898787] text-[14px] font-[400] font-[Lato] my-2">
                      {aiResponse.improvementTip}
                    </h3>
                  )}
                </div>}

                {showRegenerateButton &&
                  !aiResponse.isLoading &&
                  !aiResponse.isStreaming && (
                    <div className="mt-4 flex items-center justify-between text-xs text-gray-500">
                      <span>✨ AI-generated based on your fitness data</span>
                      <button
                        onClick={onRegenerate}
                        className="text-blue-600 hover:text-blue-800 text-xs font-medium"
                      >
                        Regenerate
                      </button>
                    </div>
                  )}
              </>
            )}
          </div>
        </div>
      </div>
  );
};

export default AISuggestionDisplay;
